import React from 'react';
import styled from "styled-components";
import {Grid, Typography} from '@material-ui/core';

const Roda = styled.div`
    
    
    background-color: black;
    margin-top: 40px;
    padding: 5%;
   
    .grid{
        width: '86%';
        color: white;
        margin-left: 2%;

        .gridItem{
            font-size: 10px;
            
        }
        a{
            text-decoration: none;
            color: white;
        }
        .copy{
            width: 86%;
            border-top: 1px solid #333;
            font-size: 13px;
            color: #999 !important;
            padding: 17px 0px 26px;
        }
    }
`;

function Footer() {
  return (
    <div>
        <Roda>
            <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="stretch"
                className="grid"
                spacing={2}
            >
                    <Grid 
                        item 
                        xs={12}
                        sm={6}
                        md={6}
                        lg={3} 
                        container 
                        direction="column" 
                        className="gridItem"
                        justify="flex-start"
                        alignItems="stretch"
                    >
                        <Grid item xs>
                            <Typography gutterBottom variant="subtitle1">
                                ACESSO RÁPIDO
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <a href="#" >Termos e Condições</a>
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <a href="#">Área Reservada</a>
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <a href="#">Políticas de Privacidade</a>
                            </Typography>
                        </Grid>  
                    </Grid>
                    <Grid 
                        item 
                        xs={12}
                        sm={6}
                        md={6}
                        lg={3} 
                        container 
                        direction="column" 
                        justify="flex-start"
                        alignItems="stretch"
                    >
                        <Grid item xs>
                            <Typography gutterBottom variant="subtitle1">
                                PERGUNTAS FREQUENTES
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <a href="#">Questões de âmbito geral</a>
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <a href="#">Processo de Constituição de Empresas</a>
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <a href="#">Sobre entidades</a>
                            </Typography>
                        </Grid>  
                    </Grid>
                    <Grid 
                        item 
                        xs={12}
                        sm={6}
                        md={6}
                        lg={3} 
                        container 
                        direction="column" 
                        justify="flex-start"
                        alignItems="stretch"
                    >
                        <Grid item xs>
                            <Typography gutterBottom variant="subtitle1">
                                CONTACTOS
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <a href="#">Contactos úteis</a>
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <a href="#">Fale connosco</a>
                            </Typography>
                            
                        </Grid>  
                    </Grid>
                    <Grid 
                        item 
                        xs={12}
                        sm={6}
                        md={6}
                        lg={3} 
                        container 
                        direction="column" 
                        justify="flex-start"
                        alignItems="stretch"
                    >
                        <Grid item xs>
                            <Typography gutterBottom variant="subtitle1">
                                MIDIAS SOCIAIS
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <a href="#">Facebook</a>
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <a href="#">Linkedin</a>
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <a href="#">Youtube</a>
                            </Typography>
                        </Grid>  
                    </Grid>
                    <span class="copy">© Copyright 2020, SEPE Serviços Públicos Electrónicos de Angola</span>
            </Grid>
            
        </Roda>
    </div>
  );
}

export default Footer;
